import React,{useRef, useContext, useEffect} from 'react'
import QuestionnaireFormDirectLoad from '../Direct/QuestionnaireFormDirectLoad'
import {QuestionnaireDirectProvider,QuestionnaireDirectContext} from './QuestionnaireDirectContext';
import * as Constants from '../Common/CommonConstants';
import MainLayoutPage from '../Common/MainLayoutPage';
import {NavControls} from '../Common/NavControls';
import {RenderDoneDialog} from '../Common/RenderDoneDialog';
import {getExternalDirect} from '../../services/dataService';


export default function CompExternalDirect(props) {    

    const  questionnaireRef= useRef(null);

    return (
        <div>
            <QuestionnaireDirectProvider>
                <MainLayoutPage navControls=
                    {
                        <BuildNavControls questionnaireRef={questionnaireRef}  />
                    } 
                    contentArea=
                    {
                        <ContentArea questionnaireRef={questionnaireRef} {...props}/>
                    }>

                </MainLayoutPage>
            </QuestionnaireDirectProvider>
        </div>
    )    
}

const ContentArea = ({questionnaireRef,...props}) => {

    const {formState,formData, doneMessage, setCompleteState,getData} = useContext(QuestionnaireDirectContext);

    useEffect(() => {        
            getData( getExternalDirect, props);
    }, []);

    if (formState === Constants.DONE_MODE || formState === Constants.SHOW_ERROR_MODE)
        return RenderDoneDialog(doneMessage,true);
    
    return <QuestionnaireFormDirectLoad ref={questionnaireRef} 
        directLoadedForm={formData}
        readOnlyMode={(formState === Constants.READ_ONLY_MODE)}
        handleRefresh={()=>setCompleteState()} 
        {...props}/>
      
}

const BuildNavControls = (questionnaireRef) => {
    
    const {formState,updateFormState,formData} = useContext(QuestionnaireDirectContext);    
    const userName = formData?formData.userName:"";

    return <NavControls questionnaireRef={questionnaireRef} formState={formState} updateFormState={updateFormState}
                                     readOnlyText="" cancelText="Cancel" userName={userName} />
}



